var Midttrafik2016 = Midttrafik2016 || {};

Midttrafik2016.search = new function () {
    var self = this;
    this.init = function () {
        this.setupSearchClick();
    };

    this.setupSearchClick = function () {
        $('.js-search-input').focus(function () {
            $(this).addClass('mini-nav-search__input--expand');
            $(this).parent('.mini-nav-search').addClass('mini-nav-search--expand');
        });
        $('.js-search-input').blur(function () {
            $(this).removeClass('mini-nav-search__input--expand');
            $(this).parent('.mini-nav-search').removeClass('mini-nav-search--expand');
            $(this).parent('.mini-nav-search').css("border-bottom", "0");
        });
        $('.js-search-input').click(function (e) {
            e.stopPropagation();
        });
        $('#search-button, #mobile-search-button, #driveplan-search-button, #front-search-button').click(function (e) {
            e.stopPropagation();
        });
        $('body').click(function () {
            $('.js-search-input').val('');
        });
        if ($('.js-routes > .search-result-box-content').children().length > 0 &&
            !$('.js-general-search > .search-result-box-content').children().length > 0) {
            $('.js-general-search').hide();
            $('.js-routes').show();
        } else if (!$('.js-routes > .search-result-box-content').children().length > 0 &&
            $('.js-general-search > .search-result-box-content').children().length > 0) {
            $('.js-general-search').show();
            $('.js-routes').hide();
        }
    };
}();
